import TagManager from 'react-gtm-module';

export const pushDataLayer = (event, payload) => {
  const eventData = {
    dataLayer: {
      event,
      ...payload,
      payload: JSON.stringify(payload),
    },
  };
  TagManager.dataLayer(eventData);
};
